// extracted by mini-css-extract-plugin
module.exports = {"nav_btn":"sidebar_nav_btn__1otgH"};